import {Provider} from 'mobx-react';
import {useMemo} from 'react';

import {AsyncPriceCourseCardContext, BrowseCourseBadgesContext} from '@udemy/browse-course';
import {FunnelLogContextProvider} from '@udemy/funnel-tracking';
import {CourseUnitStore} from '@udemy/react-discovery-units';

import {CourseUnitsProps, CourseUnits} from './course-units.react-component';

export const CourseUnitsWithProviders = ({
    provider = 'all',
    certificationBundle,
}: CourseUnitsProps) => {
    const courseUnitStore = useMemo(() => {
        const unit = {
            items: [],
            type: 'course_unit',
            remaining_item_count: 1,
        };

        const store = new CourseUnitStore('featured', unit);
        return store;
    }, []);

    return (
        <FunnelLogContextProvider pageType="featured">
            <Provider discoveryUnitsStore={courseUnitStore}>
                <BrowseCourseBadgesContext.Provider
                    value={{browseBadgeHandlerOptions: {numberOfBadgesToShow: 1}}}
                >
                    <AsyncPriceCourseCardContext.Provider
                        value={{useCourseProductCard: true, hideCourseDescription: true}}
                    >
                        <CourseUnits
                            provider={provider}
                            certificationBundle={certificationBundle}
                        />
                    </AsyncPriceCourseCardContext.Provider>
                </BrowseCourseBadgesContext.Provider>
            </Provider>
        </FunnelLogContextProvider>
    );
};
